#import './quote-banner-fragment.graphql'

fragment QuoteViewFragment on SalesDocumentView {
    id
    salesDocument {
        ... on Quote {
            ...QuoteBannerFragment
        }
        ... on Invoice {
            ...InvoiceBannerFragment
        }
    }
}
